import { forwardRef, type Ref, type SVGProps } from "react";
const IconRestoreMailFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m24.52 5.21 5.32 12.41c.109.249.163.518.16.79V26a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7.59a1.9 1.9 0 0 1 .16-.79l1.292-3.014a1 1 0 0 1 .92-.606H15.59l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4-4a1.2 1.2 0 0 0 .21-.33c.051-.12.078-.25.08-.38a.9.9 0 0 0-.08-.38 1.2 1.2 0 0 0-.21-.33l-4-4a1.004 1.004 0 1 0-1.42 1.42l2.3 2.29H6.086a1 1 0 0 1-.92-1.394L7.48 5.21A2 2 0 0 1 9.32 4h13.36a2 2 0 0 1 1.84 1.21M23.41 20H25a1 1 0 1 0 0-2h-1.79a1.5 1.5 0 0 0-1.06.44L20.59 20h-9.18l-1.56-1.56A1.5 1.5 0 0 0 8.79 18H7a1 1 0 1 0 0 2h1.59l1.56 1.57a1.5 1.5 0 0 0 1.06.43h9.58a1.5 1.5 0 0 0 1.06-.43z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconRestoreMailFilledSVG);
ForwardRef.displayName = "IconRestoreMailFilled";
export { ForwardRef as IconRestoreMailFilled };
